import {
  Component,
  HostBinding,
  Output,
  EventEmitter,
  HostListener,
  isDevMode,
} from '@angular/core';
// Polyfill for IE
import 'element-closest';
import { UserService } from './services';

interface IAugmentedElement extends Element {
  closest(selector: string): IAugmentedElement;
}

@Component({
  selector: 'app-public-sidebar',
  template: `
    <div class="header item">
      <img class="ui image logo" src="./assets/images/logo.svg" />
    </div>
    <a class="item" [routerLink]="['']">Home</a>
    <a class="item" [routerLink]="['/home-page/pay']">Pay NCC</a>
    <a class="item" [routerLink]="['/home-page/faq']">FAQs</a>
    <a class="item" [routerLink]="['/home-page/contact']">Contact</a>
    <a class="item" [routerLink]="['/home-page/sign-in']">Sign In</a>
    <a class="item" [routerLink]="['/home-page/sign-up']">Create Account</a>
  `,
  styles: [
    `
      .header.item {
        font-size: 16px;
      }
    `,
  ],
})
export class PublicSidebar {
  @Output() public onItemSelected: EventEmitter<void>;

  public get inDevMode(): boolean {
    return isDevMode();
  }

  constructor(private userSvc: UserService) {
    this.onItemSelected = new EventEmitter<void>();
  }

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    const target = event.target as IAugmentedElement;
    if (/a/i.test(target.closest('.item').tagName)) {
      this.onItemSelected.emit();
    }
  }
}
